import { render, staticRenderFns } from "./BotGenerateMesaging.vue?vue&type=template&id=3144a670&"
import script from "./BotGenerateMesaging.vue?vue&type=script&lang=js&"
export * from "./BotGenerateMesaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports